import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IInvoice, Invoice } from "@/models/invoice.entity";

export const FleetInvoiceDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IInvoice, "reportId"> {
  protected mapEntity(entity: IInvoice): IInvoice {
    return new Invoice(entity);
  }

  getIdentifier(entity: IInvoice): string {
    return entity.id;
  }

  mapsConfig = {
    reportId: {
      getIdentifier: (entity: IInvoice) => (entity.reportId ? [entity.reportId] : [])
    }
  };
})();
